import React from 'react';
import { exclametry_red_dark, eye, eyeoff, gray_tick, greenTickThick, green_tick, green_tick_dark, lineGrayTick, lineGreenTick } from '../../../../assets/images';
import { reset_password_checks } from '../../../../constants/loginContent';
import { dsButtonPrimary, joinButtonClasses } from '../../../../utils/buttonStyles';

const ResetPassword = ({
  show_password = false,
  show_confirm_password = false,
  password,
  confirm_password,
  checks,
  request_state,
  setfields,
  toggleVisiblity,
  handleSubmit,
  history,
}) => {
  const confirm_password_check = !confirm_password || confirm_password === password;
  const password_check = request_state === 'criteria-failed';
  return (
    <div>
      {['none', 'criteria-failed'].includes(request_state) ? (
        <div className='mt-16'>
          <p className='font-fig-extrabold mb-0 text-gray-900 text-2xl font-medium leading-8'>Create new password</p>

          <div className='mt-16 font-semibold text-gray-500 text-xs flex flex-col'>
            <span className='mb-3 tracking-widest leading-3 font-semibold'>PASSWORD</span>
            <div className='flex items-end'>
              <input
                id='input_password'
                type='password'
                name='password'
                placeholder='password'
                autocomplete='false'
                value={password}
                onChange={setfields}
                className={
                  'text-base caret-blue-600 text-gray-700 placeholder-gray-300 leading-4 font-semibold pl-4 border border-gray-200 rounded-md w-96 h-12 bg-gray-100 focus:bg-gray-100 focus:ring-0  focus:outline-none' +
                  (password_check ? ' border-red-600' : ' focus:border-gray-400')
                }
              />
              <img
                src={show_password ? eye : eyeoff}
                name='password'
                className='inline-block h-6 w-6 relative bottom-4 right-10 cursor-pointer'
                onClick={toggleVisiblity}
                alt='eye_icon'
              />
            </div>
            {password_check && <p className='mb-0 mt-2 text-xs text-red-600 flex flex-row'><img src={exclametry_red_dark} className='h-3 w-3 mr-1'/> Criteria needs to be fulfilled!</p>}
          </div>

          <div>
            {reset_password_checks.map((element, index) => {
              return (
                <div key={element} className='flex mt-3 items-center'>
                  <img src={checks[index] ? lineGreenTick : lineGrayTick} className='h-4 w-4 mr-2' alt='tick-icon' />
                  <p className={'mb-0 text-sm leading-4' + (checks[index] ? ' text-gray-700' : ' text-gray-400')}>{element}</p>
                </div>
              );
            })}
          </div>

          <div className='mt-12  text-gray-500 text-xs flex flex-col'>
            <span className='mb-3 tracking-widest leading-3 font-semibold'>CONFIRM PASSWORD</span>
            <div className='flex items-end'>
              <input
                id='input_confirm_password'
                type='password'
                name='confirm_password'
                placeholder='confirm password'
                autocomplete='false'
                value={confirm_password}
                onChange={setfields}
                className={
                  'text-base caret-blue-600 text-gray-700 placeholder-gray-300 leading-4 font-semibold pl-4 border border-gray-200 rounded-md w-96 h-12 bg-gray-100 focus:bg-gray-100 focus:ring-0  focus:outline-none' +
                  (confirm_password_check ? ' focus:border-gray-400' : ' border-red-600')
                }
              />
              <img
                src={show_confirm_password ? eye : eyeoff}
                name='confirm_password'
                className='inline-block h-6 w-6 relative bottom-4 right-10 cursor-pointer'
                onClick={toggleVisiblity}
                alt='eye_icon'
              />
            </div>
            {!confirm_password_check && (
              <p className='mb-0 mt-2 text-xs text-red-600'>Two passwords that you enter is inconsistent!</p>
            )}
          </div>

          <button
            onClick={handleSubmit}
            className={joinButtonClasses(dsButtonPrimary, 'mt-12 h-12 w-96 tracking-widest')}
          >
            SUBMIT
          </button>
        </div>
      ) : (
        <div className='mt-20 text-center pr-20'>
          <img src={greenTickThick} className='mb-6 mx-auto block' alt='green-tick' />
          <h1 className='font-fig-extrabold text-gray-900 text-2xl font-medium tracking-normal'>
            Your password has been reset successfully
          </h1>
          <p className='mb-0 text-base text-gray-600 mt-4 leading-4'>Please login again to continue using corporate dashbaord.</p>
          <button
            onClick={() => history.push('/login')}
            className={joinButtonClasses(dsButtonPrimary, 'mt-12 h-12 w-full tracking-widest')}
          >
            LOG IN
          </button>
        </div>
      )}
    </div>
  );
};

export default ResetPassword;
